import {
  fieldErrorsForPrefix,
  resetField,
} from "@/shared/lib/errors/validation-error";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import {
  useQpmOfferShowQuery,
  useQpmOfferUpdateRepresentativeMutation,
} from "@/services/backend/qpm/offers/api/offer-api";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Card } from "@/shared/components/ui/card";
import { useParams } from "react-router";
import { useOfferContext } from "@/routes/processes/[processId]/qpm/offers/[offerId]/_components/offer-context";

export function RepresentativeRoute() {
  const params = useParams();
  const { offerId } = params;
  const { validationError, setValidationError } = useOfferContext();
  const {
    data: offer,
    isLoading,
    error,
  } = useQpmOfferShowQuery({ id: offerId! }, { skip: !offerId });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    offer && (
      <RepresentativeCardWithMutation
        id={offer.id}
        representative={offer.representative}
        mutation={useQpmOfferUpdateRepresentativeMutation}
        debouncedMutationOptions={{ resetOnError: false }}
        validationErrorPrefix="representative"
        disabled={offer.immutable}
        fieldErrors={fieldErrorsForPrefix(validationError, "representative.")}
        resetFieldError={(field) =>
          setValidationError(
            resetField(validationError, `representative.${field}`),
          )
        }
      />
    )
  );
}
